import React from 'react'
import PropTypes from 'prop-types'

const ProgressBar = ({ progress }) => {
  return (
    <div className="progress-bar">
      <div
        className="progress-bar__fill"
        style={{ width: `${progress}%` }}
      />
      
      <p className={`progress-bar__text ${progress >= 50 ? 'progress-bar__text_white' : ''}`}>{progress}%</p>
    </div>
  )
}

export default ProgressBar

ProgressBar.propTypes = {
  progress: PropTypes.number.isRequired,
}